import {useUserStore} from "../stores/user";
import TiposConfiguracion from "@/code/TiposConfiguracion";
import KeysConfiguracion from "@/code/KeysConfiguracion";

const configraciones = {
  get(type, key) {
    const store = useUserStore();
    return store.configuraciones.find(x => x.type === type && x.key === key);
  },
  getAll() {
    const store = useUserStore();
    return store.configuraciones;
  },
  getCoordenadasInicialMapa(){
    const coordsStr = this.get(TiposConfiguracion.GENERAL, KeysConfiguracion.COORDENADAS_INICIALES_MAPAS).value;
    const coords = coordsStr.split(',');
    let lat = 0;
    let lng = 0;
    if (coords.length === 2) {
      lat = parseFloat(coords[0]);
      lng = parseFloat(coords[1]);
    }
    return {
      lat: lat,
      lng: lng,
    };
  }
};

export default configraciones;

// {{$configuraciones.get(TiposConfiguracion.ENTREGA, KeysConfiguracion.TIEMPO_ANTICIPACION).value}}
